import React, { FC } from "react";

type UserDisplayNameProps = {
  user: {
    id?: string;
    email?: string;
    displayName?: string;
  };
};

const UserDisplayName: FC<UserDisplayNameProps> = ({ user }) => {
  if (user?.displayName) {
    return <>{user?.displayName}</>;
  }

  if (user?.email) {
    return <>{user?.email}</>;
  }

  if (user?.id) {
    return <>User {user?.id}</>;
  }

  return <>Automatic System Update</>;
};
export default UserDisplayName;
